import { render, staticRenderFns } from "./CustomExport.vue?vue&type=template&id=37782098"
import script from "./CustomExport.vue?vue&type=script&lang=js"
export * from "./CustomExport.vue?vue&type=script&lang=js"
import style0 from "./CustomExport.vue?vue&type=style&index=0&id=37782098&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports